import {
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import {useRouter} from 'next/router'
import {ROUTE_ROOT} from '../../constants/routes'
import {useResetPassword, useSignOut} from '../../hooks'
import {useAuth} from '../../hooks/useAuth'
import {getRedirectTo} from '../../utils/loginHelper'
import UserDetails from './UserDetails'

const UserProfile = () => {
  const theme = useTheme()
  const [, signOut] = useSignOut()
  const [, resetPassword] = useResetPassword()

  const {t} = useTranslation('profile')
  const {user, publicUser} = useAuth().state
  const router = useRouter()

  const submitResetPassword = async () => {
    if (!user || !user.email) return

    const {error} = await resetPassword(user.email, {
      redirectTo: getRedirectTo(),
    })
    if (error) {
      const showToast = await import('../../utils/showToast').then(mod => mod.showToast)
      showToast(error.message, 'error')
    } else {
      const showToast = await import('../../utils/showToast').then(mod => mod.showToast)
      showToast(t('login:login_modal_password_reset_toast_desc'), 'success')
    }
  }

  return (
    <VStack
      w='full'
      p={5}
      spacing={5}
      borderRadius={theme.radii.big}
      background={theme.colors.layers.appLevel1}
      align='start'>
      <UserDetails email={user?.email ?? ''} apiKey={publicUser?.APIKey ?? ''} />
      {user?.app_metadata.provider == 'email' && (
        <Popover>
          {({onClose}) => (
            <>
              <PopoverTrigger>
                <Button variant='textLightPrimary'>{t('user_reset_password')}</Button>
              </PopoverTrigger>
              <Portal>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverHeader>{t('user_reset_password_confirmation_message')}</PopoverHeader>
                  <PopoverCloseButton />
                  <PopoverBody>
                    <Button
                      colorScheme='blue'
                      onClick={async () => {
                        await submitResetPassword()
                        onClose()
                      }}>
                      {t('user_reset_password_confirmation_button')}
                    </Button>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </>
          )}
        </Popover>
      )}

      <Button
        variant='textLightPrimary'
        onClick={async () => {
          await router.push(ROUTE_ROOT)
          await signOut()
        }}>
        {t('user_disconnect')}
      </Button>
    </VStack>
  )
}
export default UserProfile
